import { Type } from '@angular/core';
import { Observable } from 'rxjs';

export abstract class ScrollTriggerProvider {
  abstract scrollTrigger$: Observable<void>;
}

export function provideChatScrollTrigger(provider: Type<ScrollTriggerProvider>) {
  return [
    provider,
    {
      provide: ScrollTriggerProvider,
      useExisting: provider,
    },
  ];
}
